import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import routes from 'routes';
import { useAllowSkipCheckInSetting } from 'api/hooks/useAllowSkipCheckInSetting';

export const useNavigateToImplantsPage = () => {
  const { allowSkipImplantCheckIn } = useAllowSkipCheckInSetting();
  const navigate = useNavigate();

  const navigateToImplantsPage = useCallback(
    (id: string, isSurgeryFlow = false) => {
      if (isSurgeryFlow) {
        const route = allowSkipImplantCheckIn ? routes.SurgeryImplantList : routes.SurgeryImplants;
        navigate(route.makePath(id));
        return;
      }

      const route = allowSkipImplantCheckIn ? routes.ImplantList : routes.Implants;
      navigate(route.makePath(id));
    },
    [allowSkipImplantCheckIn, navigate],
  );

  return navigateToImplantsPage;
};
